import * as React from 'react';
import { ReactComponent as CheckIcon } from './assets/check.svg';

const Point: React.FC<{ children: React.ReactNode }> = (props) => {
  return (
    <li className="space-x-2 text-blue-100 uppercase">
      <CheckIcon className="inline" />
      <span>{props.children}</span>
    </li>
  );
};

export const Points: React.FC<{ className?: string }> = (props) => {
  return (
    <ul className={`space-y-5 border-l-2 border-white px-3 py-1 ${props.className}`}>
      <Point>LA/LB - NY/NJ</Point>
      <Point>20 port terminals</Point>
      <Point>Up to 2 years of data</Point>
      <Point>Container Status Updates</Point>
      <Point>Empty appointments</Point>
    </ul>
  );
};
